import gql from 'graphql-tag'

export default gql`
  mutation deleteModelMutation($input: DeleteModelInput!) {
    deleteModel(input: $input) {
      user {
        rid
        loan {
          rid
          businesses {
            rid
            borrowerType
            guarantors {
              rid
              affiliates {
                name
                rid
              }
            }
          }
        }
      }
    }
  }
`
